/** 一次性把所有 bridge 文档按 raw 打包进来；key 归一化为 "bridge/<slug>/index.md"，
 *  供 <DocMarkdown /> 消费。
 *
 * public/docs/bridge/ 已随仓库提交，是 build 的数据来源。dev 环境下 vite
 * 插件会额外将 monorepo 根目录 docs/bridge/ 同步过来，方便本地实时预览。
 * import.meta.glob 是编译时行为，文件内容内联到 bundle 中，运行时不会去
 * 查找外部文件。 */
const RAW = import.meta.glob('../../../../public/docs/bridge/**/index.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

export const bridgeDocs: Record<string, string> = Object.fromEntries(
  Object.entries(RAW).map(([k, v]) => [k.replace(/^.*?docs\//, ''), v])
);
